import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card, Typography, Button, Space, Result, Statistic, Row, Col } from 'antd';
import { CheckCircleFilled, ShoppingOutlined, FileTextOutlined, HomeOutlined } from '@ant-design/icons';
import './CustomerDashboard.css';

const { Title, Text } = Typography;

const OrderSuccess = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const amount = searchParams.get('amount');

  return (
    <div className="customer-page" style={{ padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Card className="customer-card" style={{ maxWidth: 500, width: '100%', textAlign: 'center' }}>
        <Result
          icon={<CheckCircleFilled style={{ color: '#52b788', fontSize: 72 }} />}
          title={<Title level={3} style={{ color: '#2d5a3d', margin: 0 }}>Order Placed Successfully!</Title>}
          subTitle="Thank you for your order. We'll send you a confirmation shortly."
        />

        <div style={{ margin: '24px 0' }}>
          <Row gutter={[16, 16]}>
            {orderId && (
              <Col span={12}>
                <Statistic title="Order ID" value={`#${orderId}`} valueStyle={{ color: '#2d5a3d' }} />
              </Col>
            )}
            {amount && (
              <Col span={12}>
                <Statistic title="Total Amount" value={`NPR ${parseFloat(amount).toFixed(2)}`} valueStyle={{ color: '#52b788' }} />
              </Col>
            )}
          </Row>
        </div>

        <Space direction="vertical" style={{ width: '100%' }} size={12}>
          {orderId && (
            <Link to={`/tracking/${orderId}`} style={{ width: '100%' }}>
              <Button type="primary" block size="large" icon={<FileTextOutlined />}
                style={{ background: 'linear-gradient(135deg, #52b788, #2d5a3d)', border: 'none', borderRadius: 10, fontWeight: 600, height: 46 }}>
                Track Your Order
              </Button>
            </Link>
          )}
          <Link to="/orders" style={{ width: '100%' }}>
            <Button block size="large" icon={<ShoppingOutlined />} style={{ borderRadius: 10, height: 46 }}>
              View All Orders
            </Button>
          </Link>
          <Link to="/dashboard" style={{ width: '100%' }}>
            <Button block size="large" icon={<HomeOutlined />} style={{ borderRadius: 10, height: 46 }}>
              Back to Dashboard
            </Button>
          </Link>
        </Space>
      </Card>
    </div>
  );
};

export default OrderSuccess;
